import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { Spin } from "antd";
import Swal from "sweetalert2";
import {
  ADD_ACTIVITY,
  getApiBaseUrl,
  UPDATE_PRESSURE,
} from "../../Config/Config";

const EditAirPressure = ({ editObj }) => {
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({
    Id: "",
    Min: 0,
    Max: 0,
    Unit: "",
  });

  useEffect(() => {
    if (editObj) {
      setFormData({
        Id: editObj?.Id || "",
        Min: editObj?.Min || 0,
        Max: editObj?.max || 0,
        Unit: editObj?.Unit || "",
      });
    }
  }, [editObj]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: name === "Min" || name === "Max" ? parseFloat(value) : value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const user = JSON.parse(sessionStorage.getItem("user"));

    const newValues = {
      ...formData,
      Type: 0,
      UpdatedBy: user?.UserID,
    };

    const oldValues = {
      Id: editObj?.Id || "",
      Min: editObj?.Min || 0,
      Max: editObj?.max || 0,
      Unit: editObj?.Unit || "",
      Type: 0,
    };

    const changedKeys = ["Min", "Max"].filter(
      (key) => newValues[key] !== oldValues[key]
    );

    const labelMap = {
      Min: "Minimum",
      Max: "Maximum",
    };

    const screenValues = changedKeys.map((key) => labelMap[key]).join(", ");
    const updateValues = changedKeys.join(", ");

    const payload = {
      ScreenName: "update Air pressure",
      ApiName: "updatePressure",
      OldValues: {
        ...oldValues,
      },
      NewValues: newValues,
      UpdateValues: updateValues,
      ScreenValues: screenValues,
      CreatedBy: user?.UserID,
    };

    setLoading(true);
    try {
      const response = await fetch(`${getApiBaseUrl()}${UPDATE_PRESSURE}`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(payload),
      });

      const data = await response.json();
      const result = data?.ResultData?.[0];

      let isSuccess = 0;

      if (data?.Status && result?.Status === "Success") {
        isSuccess = 1;
        Swal.fire("Success", "Sent to Approver", "success").then(() => {
          window.location.reload();
        });
      } else {
        Swal.fire("Error", "Update failed!", "error");
      }

      await fetch(`${getApiBaseUrl()}${ADD_ACTIVITY}`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          ActivityType: 1,
          PerformedBy: user?.UserID,
          PerformedOn: new Date().toISOString().slice(0, 19).replace("T", " "),
          Notes: "Request to update Air pressure",
          Location: "updatePressure",
          IsSucces: isSuccess,
        }),
      });
    } catch (error) {
      console.error("API error:", error);
      Swal.fire("Error", "Something went wrong!", "error");

      await fetch(`${getApiBaseUrl()}${ADD_ACTIVITY}`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          ActivityType: 1,
          PerformedBy: user?.UserID,
          PerformedOn: new Date().toISOString().slice(0, 19).replace("T", " "),
          Notes: "Request to update Air pressure",
          Location: "updatePressure",
          IsSucces: 0,
        }),
      });
    } finally {
      setLoading(false);
    }
  };
  return (
    <>
      {loading && (
        <div
          className="position-fixed top-0 start-0 w-100 h-100 d-flex align-items-center justify-content-center"
          style={{
            zIndex: 1050,
            backdropFilter: "blur(4px)",
            backgroundColor: "rgba(255, 255, 255, 0.2)", // subtle tint
          }}
        >
          <Spin size="large" tip="Processing..." />
        </div>
      )}
      <div
        className="offcanvas offcanvas-end"
        tabIndex="-1"
        id="EditAirPressureOffcanvas"
      >
        <form onSubmit={handleSubmit}>
          <div className="offcanvas-header">
            <h5 className="offcanvas-title">Edit Air Pressure</h5>
            <div className="d-flex align-items-center ms-auto">
              <button
                type="submit"
                className="btn btn-sm btn-outline-success me-2"
                title="Save"
              >
                <i className="fa fa-check fs-4"></i>
              </button>
              <button
                type="button"
                className="btn-close text-reset"
                data-bs-dismiss="offcanvas"
                aria-label="Close"
              ></button>
            </div>
          </div>
          <div className="offcanvas-body">
            <div className="mb-3">
              <label htmlFor="Min" className="form-label">
                Min Pressure
              </label>
              <input
                type="number"
                step="0.1"
                className="form-control"
                id="Min"
                name="Min"
                value={formData.Min}
                onChange={handleChange}
                required
              />
            </div>
            <div className="mb-3">
              <label htmlFor="Max" className="form-label">
                Max Pressure
              </label>
              <input
                type="number"
                step="0.1"
                className="form-control"
                id="Max"
                name="Max"
                value={formData.Max}
                onChange={handleChange}
                required
              />
            </div>
            <div className="mb-3">
              <label htmlFor="Unit" className="form-label">
                Unit
              </label>
              <input
                type="text"
                className="form-control"
                id="Unit"
                name="Unit"
                value={formData.Unit}
                onChange={handleChange}
                required
              />
            </div>
          </div>
        </form>
      </div>
    </>
  );
};

EditAirPressure.propTypes = {
  editObj: PropTypes.object,
};
export default EditAirPressure;
